import { startOfWeekLocale } from 'components/DateRangePicker/mondayBasedLocales';
import addDays from 'date-fns/addDays';
import React from 'react';
import formatDate from 'utils/formatDate';
import { TODAY_OBJECT } from '~/timeConstants';

const CSS = require('./WeekHeader.module.scss');

const START_OF_WEEKDAY = startOfWeekLocale(TODAY_OBJECT);
const WEEKDAYS = Array.from({ length: 7 }, (_, i) =>
  addDays(START_OF_WEEKDAY, i),
);

function WeekHeader() {
  return (
    <ol className={CSS.WeekHeader}>
      {WEEKDAYS.map((date, index) => (
        <li
          key={index}
          className={CSS.WeekDay}
          title={formatDate(date, 'EEEE')}
        >
          {formatDate(date, 'EEEEEE')}
        </li>
      ))}
    </ol>
  );
}

export default WeekHeader;
